/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { TimeoutError } from "exception/TimeoutError";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { TaskControlMode } from "types";
import { getErrCodeMsg, getExtendErrMsgCode } from "utils/Api";

export const useTaskRegisterErrorMessage = () => {
  const { t } = useTranslation();
  const getBaseMessage = useCallback(
    (error: unknown, mode: TaskControlMode) => {
      if (error instanceof TimeoutError) {
        switch (mode) {
          case "register":
            return t("AWVUI-MSG103");
          case "edit":
            return t("AWVUI-MSG104");
          case "approve":
            return t("AWVUI-MSG103");
          default:
            return t("AWVUI-MSG86");
        }
      } else {
        switch (mode) {
          case "register":
            return t("AWVUI-MSG47");
          case "edit":
            return t("AWVUI-MSG102");
          case "approve":
            return t("AWVUI-MSG47");
          default:
            return t("AWVUI-MSG26");
        }
      }
    },
    [t]
  );
  const getErrorMessage = useCallback(
    async (error: unknown, mode: TaskControlMode) => {
      return `${getBaseMessage(error, mode)}\n\n${await getErrCodeMsg(
        error
      )}${t(await getExtendErrMsgCode(error))}`;
    },
    [getBaseMessage, t]
  );
  return getErrorMessage;
};
